import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tempallocation',
  templateUrl: './tempallocation.component.html',
  styleUrls: ['./tempallocation.component.css']
})
export class TempallocationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
